import {Utils} from './Utils'
import {StringUtils} from './StringUtils'

export class FileUtils {
    private static _readFile(file: string, responseType: string = null, throwError: boolean = true): Promise<XMLHttpRequest> {
        responseType = Utils.valueOrDefault(responseType, null);
        throwError = Utils.valueOrDefault(throwError, true);

        return new Promise<XMLHttpRequest>((resolve, reject) => {
            let xhr = new XMLHttpRequest();
            xhr.open('GET', file, true);
            if (!StringUtils.isNullOrEmpty(responseType)) {
                xhr.responseType = responseType;
            }

            let fullfilled = false;

            function fullfill() {
                if (!fullfilled) {
                    fullfilled = true;
                    if (xhr.status === 200 || xhr.status == 0) {
                        return resolve(xhr);
                    } else {
                        let notFound = xhr.status === 404;

                        if (throwError) {
                            let msg = notFound ? `File '${file}' not found!` : `Could not load file '${file}'!`;
                            return reject(new Error(msg));
                        } else {
                            return resolve(null);
                        }
                    }
                }
            }

            xhr.onreadystatechange = () => {
                if (xhr.readyState === 4) {
                    return fullfill();
                }
            };

            xhr.onloadend = () => {
                return fullfill();
            };

            xhr.send(null);
        });
    }

    public static readLocalFile(file: string, responseType: string = null, throwError: boolean = true): Promise<string> {
        return this._readFile(file, responseType, throwError)
            .then(xhr => {
                return xhr ? xhr.responseText : '';
            });
    }

    public static readLocalJsonFile<T>(file: string, throwError: boolean = true): Promise<T> {
        return FileUtils.readLocalFile(file, null, throwError)
            .then(fileContent => {
                if (fileContent) {
                    var res = Utils.parseJson(fileContent);
                    if (res.isValid) {
                        //return Promise.resolve(res.json as T);
                        return res.json as T;
                    }

                    if (throwError) {
                        return Promise.reject(new Error(`File "${file}" content is not valid JSON object.`));
                    }
                }

                return null;
            });
    }

    public static readLocalXmlFile(file: string, throwError: boolean = true): Promise<XMLDocument> {
        return this._readFile(file, 'document', throwError)
            .then(xhr => {
                if (xhr) {
                    return xhr.responseXML as XMLDocument;
                }

                if (throwError) {
                    return Promise.reject(new Error(`File "${file}" could not be loaded.`));
                }

                return null;
            });
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Utils/FileUtils.ts
 **/